import { useCallback, useEffect, useState } from 'react';
import { checkNullString } from '@/pages/datalab/utils/utils';

export const useSqlEdit = (lazyEditor: any, initialSql: string) => {
  const [sql, setSql] = useState<string>(initialSql);
  const [cursorPosition, setCursorPosition] = useState<number[]>([0, 0]);
  const [movePosition, setMovePosition] = useState<number>(0);
  const addTableColumn = useCallback(
    (table_code: string, columnInfo: any) => {
      const lines = checkNullString(sql) ? [] : sql.split('\n');
      const indexLine = Math.min(cursorPosition[0], lines.length);
      const currentLine = lines[indexLine] || '';
      const columnName = `${table_code}.${columnInfo.column_name}`;
      const newLineSql = [
        currentLine.slice(0, cursorPosition[1]),
        columnName,
        currentLine.slice(cursorPosition[1]),
      ].join('');
      lines[indexLine] = newLineSql;
      const newSql = lines.join('\n');
      const newPosition = cursorPosition[1] + columnName.length;
      setSql(newSql);
      setCursorPosition([cursorPosition[0], newPosition]);
      setMovePosition(movePosition + 1);
    },
    [sql, JSON.stringify(cursorPosition)],
  );

  useEffect(() => {
    lazyEditor.current?.moveCursor(cursorPosition[0], cursorPosition[1]);
  }, [movePosition]);

  return { sql, setSql, setCursorPosition, addTableColumn };
};
